"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dictionariesErrorSelector = exports.dictionariesSelector = exports.isLoadingSelector = exports.getDictionaries = exports.deleteDictionary = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var notifier_1 = __importDefault(require("@utils/notifier"));
var i18next_1 = __importDefault(require("i18next"));
var apiService_1 = __importDefault(require("@common/services/apiService"));
var initialState = {
    dictionaries: [],
    error: null,
    isLoading: false,
};
var dictionarySlice = (0, toolkit_1.createSlice)({
    name: 'dictionary',
    initialState: initialState,
    reducers: {},
    extraReducers: function (builder) {
        // Add reducers for additional action types here, and handle loading state as needed
        builder.addCase(exports.deleteDictionary.fulfilled, function (state, action) {
            var name = action.meta.arg.name;
            state.dictionaries = state.dictionaries.filter(function (dictionary) { return dictionary.name !== name; });
            notifier_1.default.success(i18next_1.default.t('AUTOMATION.LISTS.DELETE_POPOVER.SUCCESS_TEXT_REACT', { dictionaryName: name }));
        });
        builder.addCase(exports.deleteDictionary.rejected, function (state, action) {
            // we don't have access to api status code and the api error
            var name = action.meta.arg.name;
            notifier_1.default.error(i18next_1.default.t('AUTOMATION.LISTS.DELETE_POPOVER.FAIL_TEXT_REACT', { dictionaryName: name }));
        });
        // builder.addCase(publishDictionary.fulfilled, (state) => {
        //   state.isLoading = false;
        //   Notifier.success(i18n.t('ITEM.MODERATION_NOTES.SUBMIT_SUCCESS_MESSAGE'));
        // });
        // builder.addCase(publishDictionary.rejected, (state) => {
        //   state.error = 'error';
        //   Notifier.error(i18n.t('ITEM.MODERATION_NOTES.SUBMIT_ERROR_MESSAGE'));
        //   state.isLoading = false;
        // });
        // builder.addCase(publishDictionary.pending, (state) => {
        //   state.isLoading = true;
        // });
        builder.addCase(exports.getDictionaries.fulfilled, function (state, action) {
            state.dictionaries = action.payload.results;
            state.isLoading = false;
        });
        builder.addCase(exports.getDictionaries.pending, function (state) {
            state.isLoading = true;
        });
        builder.addCase(exports.getDictionaries.rejected, function (state, action) {
            // we don't have access to the api error message (action.error is an empty object)
            state.error = action.error.message || 'error';
            state.isLoading = false;
        });
    },
});
exports.deleteDictionary = (0, toolkit_1.createAsyncThunk)('item/deleteDictionary', function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var name, domain;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                name = params.name, domain = params.domain;
                return [4 /*yield*/, apiService_1.default.deleteDictionary({ domain: domain, name: name })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); });
// export const publishDictionary = createAsyncThunk(
//   'item/publishDictionary',
//   async (params: { domain: string; documentId: string; noteContentText: string }) => {
//     const { documentId, domain, noteContentText } = params;
//     await ApiService.postDictionary({ domain }, { content: noteContentText, documentId });
//   },
// );
exports.getDictionaries = (0, toolkit_1.createAsyncThunk)('item/getDictionaries', function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var domain, kind, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                domain = params.domain, kind = params.kind;
                return [4 /*yield*/, apiService_1.default.getDictionaries({ domain: domain, kind: kind })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); });
var isLoadingSelector = function (state) { return state.dictionaryReducer.isLoading; };
exports.isLoadingSelector = isLoadingSelector;
var dictionariesSelector = function (state) { return state.dictionaryReducer.dictionaries; };
exports.dictionariesSelector = dictionariesSelector;
var dictionariesErrorSelector = function (state) { return state.dictionaryReducer.error; };
exports.dictionariesErrorSelector = dictionariesErrorSelector;
exports.default = dictionarySlice.reducer;
